// extracted by mini-css-extract-plugin
module.exports = {"SPVEligibilityCheckboxButton":"classes_SPVEligibilityCheckboxButton__3VCZt","secondQuestionContainer":"classes_secondQuestionContainer__1v8-4"};